export default __webpack_public_path__ + "static/media/share-icon.b7146039.svg";